// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.page-content.mystyle .form__body--card[data-v-6c958c2a] {\n    max-width: 100%;\n    margin-left: 0;\n}\n", ""]);
// Exports
module.exports = exports;
